<form [formGroup]="loginForm" (ngSubmit)="onSubmit()" *ngIf="!confirm">
    <h2 *ngIf="action === 'admin'">{{title}}</h2>
    <mat-form-field appearance="outline">
        <mat-label>Utilisateur</mat-label>
        <input matInput type="text" formControlName="user">
    </mat-form-field>
    <mat-form-field appearance="outline">
        <mat-label>Mot de passe</mat-label>
        <input matInput type="password" formControlName="password">
    </mat-form-field>

    <div class="btn_action">
        <button type="submit" class="confirm" [disabled]="loginForm.invalid" *ngIf="!isLoading"
            [style.opacity]="loginForm.invalid? .5 : 1" appChangeColorTheme attribute="bgc">Connexion</button>
        <mat-spinner *ngIf="isLoading" [diameter]="35"></mat-spinner>
    </div>
</form>

<app-validation-animation text="Connexion réussie" *ngIf="confirm && component == 'openDialog'">
</app-validation-animation>
